import { render, staticRenderFns } from "./InfoModalComponent.vue?vue&type=template&id=5bbfd7f8&"
import script from "./InfoModalComponent.vue?vue&type=script&lang=js&"
export * from "./InfoModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./InfoModalComponent.vue?vue&type=style&index=0&id=5bbfd7f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports